import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loading, EmptyState } from "@/components/common/Loading";
import LockedView from "@/pages/public/LockedView";
import { OrgProfileView } from "@/components/profile/OrgProfileView";
import { Building2 } from "lucide-react";

export default function PublicOrg({ kind }) {
  const { slug } = useParams();
  const { user, loading } = useAuth();
  const [data, setData] = useState(undefined);
  const locked = !!user && !user.email_verified;
  // 403 `account_required` = the profile exists but its owner has not enabled a public link.
  const [needsAccount, setNeedsAccount] = useState(false);
  const what = kind === "capital" ? "this capital profile" : "this business";

  useEffect(() => {
    if (loading || locked) return;
    setData(undefined);
    setNeedsAccount(false);
    api.get(`/orgs/${kind}/public/${slug}`)
      .then((r) => setData(r.data))
      .catch((e) => {
        if (e?.response?.status === 403 && e?.response?.data?.detail === "account_required") {
          setNeedsAccount(true);
        }
        setData(null);
      });
  }, [user, loading, locked, slug, kind]);

  if (loading) return <Loading />;
  if (locked) return <LockedView what={what} />;
  if (needsAccount) return <LockedView what={what} />;
  if (data === undefined) return <Loading />;
  if (data === null) return <div className="mx-auto max-w-xl px-4 py-20"><EmptyState icon={Building2} title="Not found" description="This profile may be private or no longer exists." /></div>;
  return <OrgProfileView org={data} kind={kind} />;
}
